import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { OrderDetailsEntity } from "../../../interface/order";
import { APIGetUserReassignDDL, APIReassignProjectsToSalesHead } from "../../../service/api-service";
import { APIResponseEntity } from "../../../interface/api-responce";
import { toast } from "react-toastify";
import { AxiosResponse } from "axios";
import { toastOptObj } from "../../../utils/constants";
import Loader from "../../../components/loader";

interface Props {
    visible: boolean;
    onHide: () => void;
    selectedOrders: OrderDetailsEntity[];
    onSuccess: () => void;
    userId: string;
}

function ReassignProjectsDialog({
    visible,
    onHide,
    selectedOrders,
    onSuccess,
    userId,
}: Props) {

    const [assignUser, setAssignUser] = useState("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [userDDL, setUserDDl] = useState<any[]>([])

    const FetchUserReassignDDL = async (): Promise<void> => {
        if (!selectedOrders.length) return;
        setAssignUser("");
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIGetUserReassignDDL(userId);
        setIsLoading(false);
        if (resp) {
            if (resp.status === 200 && resp.data) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp.status && axiosResp.statusCode === 200) {
                    setUserDDl(axiosResp.data)
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj });
                }
            }
        }
    };

    const handleSave = async (): Promise<void> => {
        if (!assignUser) {
            toast.error("Please select a user.", { ...toastOptObj });
            return;
        }
        setIsLoading(true);
        try {
            const payload = {
                newSalesHeadId: assignUser,
                orderIds: selectedOrders.map(order => order._id)
            };
            const resp: AxiosResponse<APIResponseEntity> = await APIReassignProjectsToSalesHead(userId, payload);
            setIsLoading(false);
            if (resp.status === 200 && resp.data) {
                const apiResp = resp.data;
                if (apiResp.status) {
                    toast.success(apiResp.message, { ...toastOptObj });
                    onSuccess();
                    handleClose();
                } else {
                    toast.error(apiResp.message, { ...toastOptObj });
                }
            }

        } catch (error) {
            setIsLoading(false);
            toast.error("Something went wrong.", { ...toastOptObj });
        }
    };

    const handleClose = () => {
        setAssignUser("");
        setUserDDl([]);
        setIsLoading(false);
        onHide();
    };

    useEffect(() => {
        if (visible && userId) {
            FetchUserReassignDDL();
        }
    }, [visible, userId]);
    return (

        <Dialog
            visible={visible}
            onHide={handleClose}
            header="Reassign Projects Before Resignation"
            style={{ width: "700px" }}
            modal
            draggable={false}
            resizable={false}
        >
            <Loader isLoading={!!isLoading} />
            <div className="mb-3 fw-bold">
                Total Projects : {selectedOrders.length}
            </div>

            <DataTable
                value={selectedOrders}
                responsiveLayout="scroll"
            >
                <Column
                    field="orderNumber"
                    header="ORDER NUMBER"
                />
                <Column
                    field="projectName"
                    header="PROJECT NAME"
                />
                <Column
                    field="clientName"
                    header="CLIENT NAME"
                />
            </DataTable>
            <div className="mt-4">
                <label className="form-label">
                    Assign To User
                </label>
                <Dropdown
                    value={assignUser}
                    options={userDDL}
                    optionLabel="userName"
                    optionValue="userId"
                    filter
                    className="w-100"
                    placeholder="Select User"
                    onChange={(e) =>
                        setAssignUser(e.value)
                    }
                />
            </div>
            <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                    type="button"
                    className="btn btn-cancel"
                    onClick={handleClose}
                >
                    Cancel
                </button>

                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSave}
                    disabled={!assignUser || isLoading}
                >
                    {isLoading ? "Saving..." : "Save Changes"}
                </button>
            </div>
        </Dialog>
    );
}

export default ReassignProjectsDialog;